/* tslint:disable */
/* eslint-disable */
/**
 * axfoodstorefront API
 * axfoodstorefront Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SearchFilterQueryData } from './search-filter-query-data';

/**
 * 
 * @export
 * @interface SearchQueryData
 */
export interface SearchQueryData {
    /**
     * 
     * @type {Array<SearchFilterQueryData>}
     * @memberof SearchQueryData
     */
    'filterQueries'?: Array<SearchFilterQueryData>;
    /**
     * 
     * @type {string}
     * @memberof SearchQueryData
     */
    'searchQueryContext'?: SearchQueryDataSearchQueryContextEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchQueryData
     */
    'searchType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchQueryData
     */
    'value'?: string;
}

export const SearchQueryDataSearchQueryContextEnum = {
    Default: 'DEFAULT',
    Suggestions: 'SUGGESTIONS'
} as const;

export type SearchQueryDataSearchQueryContextEnum = typeof SearchQueryDataSearchQueryContextEnum[keyof typeof SearchQueryDataSearchQueryContextEnum];


